import { Headers, Http, Request, RequestOptions, RequestOptionsArgs, Response, ResponseContentType } from '@angular/http';
import { Injectable, EventEmitter } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';
import { DownloadFileTypesEnum } from '../utils/enums/downloadFileTypesEnum';
import { String } from '../utils/utils/strings';
import { TokenService } from './token.service';
import { Message } from '../utils/utils/message';
import { Router } from '@angular/router';


declare var $: any;

@Injectable()
export class HttpService {

    public usuario: any;
    public loadingChange: Subject<boolean>;
    isLoading: boolean;
    trace: boolean;
    showMsgError: boolean;
    onTokenExpired: EventEmitter<any>;

    constructor(private http: Http , private tokenService: TokenService, private router: Router) {
        this.loadingChange = new Subject<boolean>();
        this.isLoading = false;
        this.trace = true;
        this.showMsgError = true;
        this.onTokenExpired = new EventEmitter<any>();
    }

    get(url: string, showLoading: boolean = true, showMsgError: boolean = true, options?: RequestOptionsArgs): Promise<any> {
        if (showLoading) {this.enableLoadingAndTrace('get(' + url + ')'); }
        this.showMsgError = showMsgError;
        options = this.anyadirAutorizacion(options);
        return this.http.get(url, options)
            .toPromise()
            .then(this.handleResult.bind(this))
            .catch(this.handleError.bind(this));
    }

    authGet(url: string, showLoading: boolean = true, showMsgError: boolean = true, options?: RequestOptionsArgs): Promise<any> {
      if (showLoading) { this.enableLoadingAndTrace('authGet(' + url + ')'); }
      options = this.setJWTHeaders(options);
      options.withCredentials = true;
      this.showMsgError = showMsgError;

      return this.http.get(url, options)
          .toPromise()
          .then(this.handleResult.bind(this))
          .catch(this.handleError.bind(this));
  }

    post(url: string, body: any, showLoading: boolean = true, showMsgError: boolean = true, options?: RequestOptionsArgs): Promise<any> {
        if (showLoading) {this.enableLoadingAndTrace('post(' + url + ')'); }
        options = this.anyadirAutorizacion(options);
        this.showMsgError = showMsgError;

        return this.http.post(url, body, options)
            .toPromise()
            .then(this.handleResult.bind(this))
            .catch(this.handleError.bind(this));
    }

    put(url: string, body: any, showLoading: boolean = true, showMsgError: boolean = true, options?: RequestOptionsArgs): Promise<any> {
        if (showLoading) {this.enableLoadingAndTrace('put(' + url + ')'); }
        options = this.anyadirAutorizacion(options);
        this.showMsgError = showMsgError;

        return this.http.put(url, body, options)
            .toPromise()
            .then(this.handleResult.bind(this))
            .catch(this.handleError.bind(this));
    }

    delete(url: string, showLoading: boolean = true, showMsgError: boolean = true, options?: RequestOptionsArgs ): Promise<any> {
        if (showLoading) {this.enableLoadingAndTrace('delete(' + url + ')'); }
        this.showMsgError = showMsgError;
        options = this.anyadirAutorizacion(options);
        return this.http.delete(url, options)
            .toPromise()
            .then(this.handleResult.bind(this))
            .catch(this.handleError.bind(this));
    }


    /**
     * Realiza un HTTP Post para descargar un fichero.
     */
    downloadFileFromGet(url: string, params: any, fileName: string, fileType: DownloadFileTypesEnum): Promise<any> {
        return new Promise(
            (resolve, reject) => {
                this.downloadFileFromGetBase(url, params, fileName, fileType)
                    .subscribe(data => {
                        // dependiendo del navegador se usa el blob de una forma u otra
                        const navVersion = window.navigator.appVersion;
                        if (navVersion.indexOf('Trident') !== -1 || navVersion.indexOf('MSIE') !== -1 ||
                        navVersion.indexOf('Edge') !== -1) {
                            window.navigator.msSaveOrOpenBlob(data, fileName);
                        } else {
                            const a = document.createElement('a');
                            a.href = URL.createObjectURL(data);
                            a.download = fileName;
                            document.body.appendChild(a);
                            a.click();
                        }

                        resolve(true);
                    },
                    err => {
                        reject(err);
                    });

            });
    }

    downloadFileFromGetBase(url, params, fileName, fileType: DownloadFileTypesEnum): Observable<Response> {
        let blobType: string = null;
        switch (fileType) {
            case DownloadFileTypesEnum.Excel:
                // blobType = 'application/vnd.ms-excel';
                blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                break;
            default:
                blobType = 'application/octet-stream';
                break;
        }

        const reqOpts = { headers: new Headers, responseType: ResponseContentType.Blob };
        reqOpts.headers.set('Token', this.usuario);

        return this.http.get(url, reqOpts)
            .map(res => new Blob([res.blob()], { type: blobType }))
            .catch(this.handleError);
    }

    extractData(res: Response) {
        if (res && res.status === 200) {
            const body = res.json();
            if (body) {
                return body || body.data;
            } else {
                return {};
            }
        } else {
            return {};
        }
    }

    extractDataValues(res: Response) {
        if (res && res.status === 200) {
            const body = res.json();
           // console.log(body);
            if (body) {
                return body;
            } else {
                return {};
            }
        } else {
            return {};
        }
    }

    extractDataOk(res: Response): boolean {
        if (res && res.status === 200) {
            return true;
        } else {
            return false;
        }
    }

    extractDataBoolean(res: Response): boolean {
        if (res && res.status === 200) {
            const body = res.json();
            if (body) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    private enableLoadingAndTrace(logMessage: string) {
        if (this.trace) { }
        this.isLoading = true;
        this.loadingChange.next(this.isLoading);
    }

    private disableLoading() {
        this.isLoading = false;
        this.loadingChange.next(this.isLoading);
    }

    private handleResult(data: any): Promise<any> {
        const self = this;
        if (self.trace) { }
        self.disableLoading();
        return Promise.resolve(data);
    }

    private handleError(error: any): Promise<any> {
        const self = this;
        let body;
        let message: string;
        if (error != null) {
            if (error._body != null) {
                   body = error.json();
                if (error.status === 500) {
                    message = error.ExceptionMessage;
                } else if (error.status === 400 || error.status === 404) {
                    message = error.Message;
                } else {
                    message = error.json();
                }
            }

            if (String.IsNullOrWhiteSpace(message)) {
                message = error.message || error.statusText || error.ExceptionMessage || error;
            }

            if (message === 'No JWT present or has expired') {
                this.onTokenExpired.emit(null);
            }

            if (self.trace) { }
            self.disableLoading();
            if (self.showMsgError) {
                Message.toast(body.Mensaje, 'error');
            }
        }
        return Promise.reject(message);
    }

    private setHeaderToForms(options?: RequestOptionsArgs, formHeader?: boolean): RequestOptionsArgs {
      options = options || new RequestOptions();
      options.headers = options.headers || new Headers();
      if (!options.headers.has('Content-Type')) {
          if (formHeader) {
              options.headers.append('Content-Type', 'application/X-www-form-urlencoded');
          } else {
              options.headers.append('Content-Type', 'application/json');
          }
      }

      return options;
  }

    private anyadirAutorizacion(options?: RequestOptionsArgs, formHeader?: boolean): RequestOptionsArgs {
      options = options || new RequestOptions();
    // tslint:disable-next-line: deprecation
      options.headers = options.headers || new Headers ();
      options.headers.set('authorization', 'Basic ' + this.tokenService.getToken());
      options.headers.set('content-type', 'application/json');
      return options;
    }


    private setJWTHeaders(options?: RequestOptionsArgs) {
      options = options || new RequestOptions();
      options.headers = options.headers || new Headers();
      options.headers.append('authorization', 'Bearer ' + this.tokenService.getToken());
      return options;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/http.service.ts